import {useQuery} from '@tanstack/react-query';
import {useRequiredTenantId} from '@/matic/hooks/useRequiredTenantId';
import {getFilesApi} from '../api/files-api';
import {filesKeys} from '../query-keys';

export function useFileTags() {
  const tenantId = useRequiredTenantId();
  const api = getFilesApi();

  return useQuery({
    queryKey: filesKeys.categories.all(tenantId),
    queryFn: async () => api.listCategories(),
  });
}
